import * as moment_ from 'moment';
const moment = moment_;

export class DateUtil {

	private formato!: string;
	public meses: string[] = [];
	public fechaPattern: RegExp = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
	public as: RegExp = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;

	constructor() {
		this.setLocale('es');
	}

	parseStringToDate(fecha: string, formatoFrom: string){
		return moment(fecha, formatoFrom).toDate();
	}
	addSeconds(fecha : Date, secondsToAdd: number) : Date{
		let initialDate = moment(fecha);
		let dateIncreased = initialDate.add(secondsToAdd, 's');
		return dateIncreased.toDate();
	}
	formatDateTo(fecha: Date, formatoTo: string): string {
		return moment(fecha).format(formatoTo);
	}
	setLocale(str: string) {
		moment.locale(str);
		this.formato = this.getLocaleFormat();
		this.fechaPattern = this.loadPattern();
		this.loadMonth();
	}

	getLocaleFormat(): string {
		return moment.localeData().longDateFormat('L');
	};

	dateToStr(fecha: Date): string {
		return moment(fecha).format(this.formato);
	}

	strToDate(str: string): Date {
		return moment(str, this.formato).toDate();
	}

	getLastDayFromMonth(str: string): string {
		return moment(str, this.formato).endOf('month').format(this.formato);
	}

	getFirstDayFromMonth(str: string): string {
		return moment(str, this.formato).startOf('month').format(this.formato);
	}

	getFirstDayOfCurrentMonth() {
		return moment().startOf('month').format(this.formato);
	}

	getLastDayOfCurrentMonth() {
		return moment().endOf('month').format(this.formato);
	}

	getNow(): string {
		return moment().format(this.formato).toString();
	}

	getDayFromDate(fecha: Date): string {
		return moment(fecha).format('D');
	}

	getMonthFromDate(fecha: Date): string {
		return moment(fecha).format('M');
	}

	getYearFromDate(fecha: Date): string {
		return moment(fecha).format('YYYY');
	}

	loadMonth(): void {
		this.meses = [''];
		for (let x = 0; x < 12; x++) {
			this.meses.push(moment(new Date(2000, x, 1)).format('MMMM'));
		}
	};

	dateAutoComplete(fecha : any) {
		let now = new Date();
		let dia;
		let mes;
		let anio;
		switch (fecha.length) {
			case 1:
			case 2:
				dia = fecha.padStart(2, '0');
				mes = (now.getMonth() + 1).toString().padStart(2, '0');
				anio = now.getFullYear();
				break;
			case 3:
			case 4:
				dia = fecha.substring(0, 2);
				mes = fecha.substring(2, 4).padStart(2, '0');
				anio = now.getFullYear();
				break;
			case 6:
				dia = fecha.substring(0, 2);
				mes = fecha.substring(2, 4);
				anio = '20' + fecha.substring(4, 6);
				break;
			case 8:
				dia = fecha.substring(0, 2);
				mes = fecha.substring(2, 4);
				anio = fecha.substring(4);
				break;
			case 10:
				if (moment(fecha, this.formato).isValid()) {
					let d = this.strToDate(fecha);
					dia = d.getDay();
					mes = d.getMonth() + 1;
					anio = d.getFullYear();
				}
				break;
		}
		if (typeof dia !== 'undefined' || typeof mes !== 'undefined' || typeof anio !== 'undefined') {
			return this.dateToStr(new Date(anio, mes - 1, dia));
		} else {
			return moment().format(this.formato);
		}
	}
	validatorFecha(fch: string) {
		const datedFch = moment(fch, this.formato, true);
		const valid = datedFch.isValid().valueOf();
		let errfch = ''
		if (!valid) {
			const invalidAtFchDesde = datedFch.invalidAt();
			errfch = this.momentValidation(invalidAtFchDesde);
		}
		return { valid, errfch };
	}

	// validacionFecha(fch: string) {
	// 	let datedFch = moment(fch, this.formato, true);
	// 	let valid = datedFch.isValid().valueOf();
	// 	if (!valid) {
	// 		let invalidAtFchDesde = datedFch.invalidAt();
	// 		let errfch = this.momentValidation(invalidAtFchDesde);
	// 		if (typeof errfch !== 'undefined') {
	// 			return errfch;
	// 		}
	// 	}
	// }

	momentValidation(invalidAt: number) {
		let invalidMessage: string;
		switch (invalidAt) {
			case 0:
				invalidMessage = 'Año no válido';
				break;
			case 1:
				invalidMessage = 'Mes no válido';
				break;
			case 2:
				invalidMessage = 'Día No válido para el mes ingresado';
				break;
			default:
				invalidMessage = 'Fecha Invalida o campo vacio';
				break;
		}
		return invalidMessage;
	}
	//agregue return vacio
	datesComparisson(fchdesde: string, fchhasta: string) {
		let datedfchDesde = this.strToDate(fchdesde);
		let datedfchHasta = this.strToDate(fchhasta);
		if (datedfchDesde > datedfchHasta) {
			return 'La Fecha Final no puede ser menor a la Fecha de Inicio.';
		}else{
			return;
		}
	}

	formatDateYMD(fecha : any) {
		if (fecha !== '') {
			return moment(fecha, this.formato).format('YYYY-MM-DD');
		}
		return fecha;
	}

	loadPattern(): RegExp {
		let spliter = this.formato.replace(/Y/g, '').replace(/M/g, '').replace(/D/g, '');
		let pattern = '';
		if (spliter.length > 0) {
			let elements = this.formato.split(spliter.substring(0, 1));
			elements.forEach(element => {
				if (element.substring(0, 1) === 'D') {
					if (pattern !== '') {
						pattern += '(' + JSON.stringify(String(spliter.substring(0, 1))).slice(1, -1) + ')';
					}
					pattern += '([0-2][0-9]|(3)[0-1])';
				} else if (element.substring(0, 1) === 'M') {
					if (pattern !== '') {
						pattern += '(' + JSON.stringify(String(spliter.substring(0, 1))).slice(1, -1) + ')';
					}
					pattern += '(((0)[0-9])|((1)[0-2]))';
				} else if (element.substring(0, 1) === 'Y') {
					if (pattern !== '') {
						pattern += '(' + JSON.stringify(String(spliter.substring(0, 1))).slice(1, -1) + ')';
					}
					pattern += '\\d{4}';
				}
			});
		}
		return new RegExp(`^${pattern}$`);
	}
}
